
export const CURRENCY_CONVERTER_KEY="b37034a952fa5b9cf619a5a9"



export const COOKING_TYPE=["Baked","Raw","Grilled Fried","Deep Fried","Fresh"];
export const COLOR=["All Natural Color","No Color Aditions"];
export const FOOD_MADE=["Hand Made","Factory Made"];
export const SELER_TYPE=["Private","Family Owned"];
export const VERIFICATION_TYPE=["Health Board","Food Safety"];



export const FIREBASE_ERRORS = {
    userAlreadyExists: "Firebase: Error (auth/email-already-in-use).",
    invalidCredential: "Firebase: Error (auth/invalid-credential)."
}
export const FORM_TYPES = {
    login: 'Login',
    signUp: 'Sign Up',
    restaurantType: 'Restaurant Sign Up'
  }

export const USER_ROLES = {
    user: "user",
    restaurant: "restaurant"
}

export const FOOD_GROUP = ["Vegan", "Vegetarian", "Vegetarian and Non-Vegetarian", "Non-Vegetarian"];
export const FOOD_MAKE = ["Ready to Eat Food", "Fresh Chilled Food", "Fresh Raw Food", "Frozen Food","Dry Food"];
export const FOOD_FREE_FROM = ["Gluten ,Wheat", "Nuts", "Dairy Milk", "Egg", "Additives", "Monosodium Glugamate", "Colouring"];
export const FOOD_VARIETY = ["Pizza", "Burger", "Kebab", "Roll", "Snacks", "Noodle", "Chowmein", "Biriyani", "Tikka", "Fish and Chips",
    "Rousted Chicken", "Rice", "Curry", "Soup", "Masala", "Cake", "Salad",
    "Pickles", "Souce", "Sandwich", "Subway", "Steak Meat", "Fried Chicked",
    "Bread","Other"
];

export const CALORIES_COUNT_RANGE = ["100-250","250-500","500-750","750-1000","1000-1250","1250-1500","1500-2000","2000-2500","2500-3000"];


export const PRICE_RANGE = ["50-1000", "1000-2000", "2000-5000", "Above 5000"];

export const VIDEO_EXTENSION_TYPES = [
    'video/mp4',
    'video/x-m4v',
    'video/quicktime',
    'video/x-msvideo',
    'video/x-ms-wmv',
    'video/3gpp',
    'video/3gpp2',
    'video/webm',
    'video/x-flv',
    'video/ogg',
    'video/mpeg',
]
export const IMAGE_EXTENSION_TYPES = [
    'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'tif', 'tiff', 'ico'
]
export const PAYPAL_TEST_KEY="AeKBM66Redlym7FwwLDC62Ou-EGurie5sXzF2K3PzBMpPacNyROma3IX59CSS_oF70vU_kJFgPSjdIaO"